import { OBJECT_TYPES } from "../constants/project";
import { FontListForPDFFormFields } from "./font-list";
import { openCenterPopup } from "../helpers/app";

export const FieldObject = {
  objectType: OBJECT_TYPES.DETECTED_FIELD,
  attributes: [
    {
      name: "altFieldName",
      defaultValue: null,
      validation: [],
      type: "string",
      validValues: [],
      disabled: true,
    },
    {
      name: "pages",
      defaultValue: null,
      validation: [],
      type: "string",
      validValues: [],
      disabled: true,
    },
    {
      name: "text",
      defaultValue: null,
      validation: [],
      type: "auto",
      validValues: [],
      disabled: false,
      autoFocus: true,
      showName: "value",
    },
    {
      name: "fontName",
      defaultValue: null,
      validation: [],
      type: "select",
      validValues: [...FontListForPDFFormFields],
      disabled: false,
    },
    {
      name: "size",
      defaultValue: null,
      validation: [
        {
          type: "number",
          min: 1,
          message: "Size input must be greater than 1!",
        },
      ],
      type: "number",
      validValues: [],
      disabled: false,
    },
    {
      name: "color",
      defaultValue: null,
      validation: [],
      type: "text",
      validValues: [],
      disabled: false,
      hint: (
        <div>
          Enter color in a form of <code>#RRGGBB</code> or{" "}
          <code>#AARRGGBB</code> (with transparency). Check supported color
          values
          <a
            target="popup"
            onClick={() => {
              openCenterPopup(
                "https://apidocs.pdf.co/kb/Fill%20PDF%20and%20Add%20Text%20or%20Images%20(pdf-edit-add)/text-colors",
                800,
                600
              );
              return false;
            }}
            className="ms-1"
          >
            here
          </a>
        </div>
      ),
    },
    {
      name: "fontBold",
      defaultValue: null,
      validation: [],
      type: "boolean",
      validValues: [],
      disabled: false,
    },
    {
      name: "fontItalic",
      defaultValue: null,
      validation: [],
      type: "boolean",
      validValues: [],
      disabled: false,
    },
    {
      name: "fontStrikeout",
      defaultValue: null,
      validation: [],
      type: "boolean",
      validValues: [],
      disabled: false,
    },
    {
      name: "fontUnderline",
      defaultValue: null,
      validation: [],
      type: "boolean",
      validValues: [],
      disabled: false,
    },
  ],
};
